import React from 'react';
import './InfoModal.scss'

export interface InfoModalProps {
    children: any;
    width: string;
    ariaLabel?: string;
    ariaLabelledBy?: string;
}

const InfoModal: React.FC<InfoModalProps> = (props) => {
    return (
        <div
            className='infoModal'
            style={{ width: props.width }}
            role="dialog"
            aria-modal="true"
            aria-labelledby={props.ariaLabelledBy}
            aria-label={props.ariaLabelledBy ? undefined : (props.ariaLabel || 'Information')}
        >
            {props.children}
        </div>
    );
}

export default InfoModal;
